import React from "react";
import CardRow from "./CardRow";

interface Card {
  id: string;
  isDefault: boolean;
  brand: string;
  last4: string;
}

interface CardDetailsTableProps {
  cardDetails: Card[];
  payNow: (id: string) => void;
}

const CardDetailsTable: React.FC<CardDetailsTableProps> = ({ cardDetails, payNow }) => {
  return (
    <table className="w-100" cellPadding={5} cellSpacing={5}>      <thead>
        <tr>
          <th style={{ width: "250px" }}>Default</th>
          <th style={{ width: "100px" }}>Brand</th>
          <th style={{ width: "400px" }}>Last 4 Digits</th>
          <th style={{ width: "250px" }}>Action</th>
        </tr>
      </thead>      <tbody>
        {cardDetails.map((card) => (
          <CardRow 
            key={card.id}
            card={card}
            payNow={payNow}
          />
        ))}
      </tbody>
    </table>
  );
};

export default CardDetailsTable;
